import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { HookSection } from '../components/landing/HookSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { MethodSection } from '../components/landing/MethodSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { AudienceSection } from '../components/landing/AudienceSection';
import { StepsSection } from '../components/landing/StepsSection';
import { FAQSection } from '../components/landing/FAQSection';
import { PricingSection } from '../components/landing/PricingSection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-orange-200 selection:text-orange-900" data-id="element-191">
      <main data-id="element-192">
        <HeroSection data-id="element-193" />
        <HookSection data-id="element-194" />
        <ProblemSection data-id="element-195" />
        <MethodSection data-id="element-196" />
        <BenefitsSection data-id="element-197" />
        <AudienceSection data-id="element-198" />
        <StepsSection data-id="element-199" />
        <FAQSection data-id="element-200" />
        <PricingSection data-id="element-201" />
      </main>

      <Footer data-id="element-202" />
    </div>;
}